import styled from "styled-components";

export const Wrapper = styled.div`
    height: 72px;
    background-color: #ffff;
    padding: 0 42px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
